import React, { createContext, useContext, useState } from "react";

const TeamAuthorizationContext = createContext();

export const useTeamAuthorization = () => {
    return useContext(TeamAuthorizationContext);
};

export const TeamAuthorizationProvider = ({ value, children }) => {
    const [showArchived, setShowArchived] = useState(false);

    const contextValue = {
        ...value,
        showArchived,
        setShowArchived,
    };
    return (
        <TeamAuthorizationContext.Provider value={contextValue}>
            {children}
        </TeamAuthorizationContext.Provider>
    );
};
